module.exports = __webpack_public_path__ + "static/img/technologyu04.f2dccc5b.png";